import React from "react";
import RecordingMicPopover from "./RecordingMicPopover";

const MicPopover = ({
  isActive,
  streamingTranscript,
  dictationLanguage,
  isCommandMode = false,
  onStop,
  isRadicalAuth = false,
}) => (
  <RecordingMicPopover
    isActive={isActive}
    streamingTranscript={streamingTranscript}
    dictationLanguage={dictationLanguage}
    isCommandMode={isCommandMode}
    onStop={onStop}
    isRadicalAuth={isRadicalAuth}
    variant="editor"
  />
);

export default MicPopover;
